(($)=>{
    "use strict";

    if(window['objectFitImages']){

        $(document).ready(function(){

            window.objectFitImages(null, {watchMQ: true});

        });

    }

})(jQuery)